import React from 'react';
import { require } from 'js/backbone/portlets';
import { componentService } from 'js/services/component.service';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';

class DefaultHeaderWrapper extends React.Component {
    componentDidMount() {
        require(['portlets_header_header_model'], (Model) => {
            const model = new Model();

            this.view = model.getView();
            this.view.setElement(this.el).render();
        });
    }

    componentWillUnmount() {
        this.view && this.view.close();
    }

    render() {
        return <BackboneWrapper el={el => this.el = el} classes='page-header' />;
    }
}

export const DefaultHeader = () => <DefaultHeaderWrapper />;

componentService.registerWebContentComponents({ DefaultHeader });
